import React from "react";

const Edit1Icon = ({ width, height, color }) => {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4.53333H12.1329V6.8H0V4.53333ZM0 2.26667H12.1329V0H0V2.26667ZM0 11.3333H7.72094V9.06667H0V11.3333ZM16.5559 7.786L17.339 6.98133C17.7692 6.53933 18.4641 6.53933 18.8943 6.98133L19.6774 7.786C20.1075 8.228 20.1075 8.942 19.6774 9.384L18.8943 10.1887L16.5559 7.786ZM15.7728 8.59067L9.92693 14.5973V17H12.2653L18.1111 10.9933L15.7728 8.59067Z"
        fill="white"
      />
    </svg>
  );
};
export default Edit1Icon;
